import { newsFromUsData } from './newsFromUsData';
export const newsData = [
    ...newsFromUsData,
  {
    id: 'uzbekistan-2030-vision',
    date: '2026-01-06',
    category: 'Diplomacy',
    image: 'https://www.qha.com.tr/cdn/zhxu6VS04gIDF7KoM-g1QxGhiLI=/750x500/webp/2026/01/06/ozbekistan-in-kuresel-entegrasyonu-taskent-in-2030-icin-hedefleri-1767706831-149_large.webp',
    featured: true,
    translations: {
      en: {
        title: "Uzbekistan's 2030 Vision: Uzbek Passport Opens to the World!",
        excerpt: "The Uzbekistan government has published the draft '2026-2030 Country Development Strategy'. Uzbekistan aims to achieve visa-free entry to 50 countries by 2030.",
        content: `The Uzbekistan government has published the draft "2026-2030 Country Development Strategy". According to this draft, Uzbekistan aims to achieve visa-free entry to 50 countries by 2030.

**VISA-FREE TRAVEL FREEDOM FOR UZBEKISTAN CITIZENS WILL INCREASE**

According to data from the Uzbekistan Ministry of Foreign Affairs, Uzbek citizens can currently enter 35 countries visa-free and 42 countries with simplified procedures.

**UZBEKISTAN PASSPORT IS GETTING STRONGER**

Among Uzbekistan's 2030 targets; facilitating the international mobility of businesspeople and investors, increasing the access of Uzbek youth and tourists to overseas opportunities, and raising the ranking of the Uzbekistan passport in global indexes.`
      },
      tr: {
        title: "Özbekistan'ın 2030 vizyonu: Özbek pasaportu dünyaya açılıyor!",
        excerpt: "Özbekistan hükûmeti, '2026-2030 Ülke Geliştirme Stratejisi' taslağını yayımladı. Özbekistan, 2030 yılına kadar 50 ülkeye vizesiz giriş yapabilmeyi hedefliyor.",
        content: `Özbekistan hükûmeti, "2026-2030 Ülke Geliştirme Stratejisi" taslağını yayımladı. Bu taslağa göre Özbekistan, 2030 yılına kadar 50 ülkeye vizesiz giriş yapabilmeyi hedefliyor.

**ÖZBEKİSTAN VATANDAŞLARININ VİZESİZ SEYAHAT ÖZGÜRLÜĞÜ ARTACAK**

Özbekistan Dışişleri Bakanlığının verilerine göre Özbek vatandaşları, hâlihazırda 35 ülkeye vizesiz, 42 ülkeye ise basitleştirilmiş prosedürlerle giriş yapabiliyor.

**ÖZBEKİSTAN PASAPORTU GÜÇLENİYOR**

Özbekistan'ın 2030 yılı hedefleri arasında; iş insanlarının ve yatırımcıların uluslararası hareketliliğini kolaylaştırmak, Özbek gençleriyle Özbek turistlerin yurt dışı imkânlarına erişimini artırmak ve Özbekistan pasaportunun küresel endekslerdeki sıralamasını yükseltmek bulunuyor.`
      }
    }
  },
  {
    id: 'azerbaijan-digital-transformation-ai',
    date: '2026-01-06',
    category: 'Technology',
    image: 'https://www.qha.com.tr/cdn/JHn9mHerLMOTUOM63nGS4LiU88A=/750x500/webp/2026/01/06/azerbaycan-dijital-donusum-ve-yapay-zekada-tarihi-basari-elde-etti-1767692083-893_large.webp',
    featured: true,
    translations: {
      en: {
        title: "Azerbaijan Achieves Historic Success in Digital Transformation and AI",
        excerpt: "Azerbaijan jumped 41 places in the '2025 Government AI Readiness Index' report published by Oxford Insights.",
        content: `Azerbaijan started 2026 with momentum. According to the "2025 Government AI Readiness Index" report published by Oxford Insights, Azerbaijan jumped 41 places in one year.

**AZERBAIJAN TAKES THE LEAD IN THE SOUTH CAUCASUS**

Azerbaijan achieved the highest result in the South Caucasus region with 48.96 overall points.

**ARTIFICIAL INTELLIGENCE IS INTEGRATING INTO THE TURKIC WORLD**

Turkey is ranked 48th with 58.10 points, Kazakhstan 60th with 55.86 points, Uzbekistan 62nd with 54.69 points.`
      },
      tr: {
        title: "Azerbaycan, dijital dönüşüm ve yapay zekâda tarihi başarı elde etti",
        excerpt: "Azerbaycan, Oxford Insights tarafından yayınlanan '2025 Hükûmet Yapay Zeka Hazırlık Endeksi' raporunda 41 basamak birden yükseldi.",
        content: `Azerbaycan, 2026 yılına hızlı bir giriş yaptı. Oxford Insights tarafından yayınlanan "2025 Hükûmet Yapay Zeka Hazırlık Endeksi" raporuna göre Azerbaycan, bir yıl içerisinde 41 basamak birden yükseldi.

**AZERBAYCAN, GÜNEY KAFKASYA'DA LİDERLİĞİ ELDE ETTİ**

Azerbaycan, 48,96 genel puan ile Güney Kafkasya bölgesinde en yüksek sonucu elde etti.

**YAPAY ZEKÂ, TÜRK DÜNYASINA ENTEGRE OLUYOR**

Türkiye 58,10 puanla 48., Kazakistan 55,86 puanla 60., Özbekistan 54,69 puanla 62. sırada yer alıyor.`
      }
    }
  },
  {
    id: 'turkey-azerbaijan-gas-agreement',
    date: '2026-01-05',
    category: 'Economy',
    image: 'https://www.qha.com.tr/static/2026/01/05/turkiye-ile-azerbaycan-arasinda-yeni-bir-dogal-gaz-tedarik-anlasmasina-imza-atildi-1767601900-207_small.jpg',
    featured: false,
    translations: {
      en: {
        title: "New Agreement Signed Between Turkey and Azerbaijan",
        excerpt: "Turkey and Azerbaijan signed a natural gas supply agreement of 33 billion cubic meters.",
        content: `Turkey and Azerbaijan signed a natural gas supply agreement. Energy Minister Alparslan Bayraktar announced that supply will begin in 2029.

**"GAS WILL COME FROM THE CASPIAN SEA"**

There will be an annual production of 2.25 billion cubic meters in the Absheron Field for 15 years until the 2040s.`
      },
      tr: {
        title: "Türkiye ile Azerbaycan arasında yeni bir anlaşmaya imza atıldı",
        excerpt: "Türkiye ile Azerbaycan 33 milyar metreküplük bir doğal gaz tedarik anlaşmasına imza attı.",
        content: `Türkiye, Azerbaycan ile doğal gaz tedarik anlaşmasına imza attı. Enerji Bakanı Alparslan Bayraktar, tedarikin 2029'da başlayacağını bildirdi.

**"GAZ, HAZAR DENİZİ'NDEN GELECEK"**

Abşeron Sahası'nda yıllık 2,25 milyar metreküp üretim olacak ve 15 yıl boyunca 2040'lı yıllara kadar alınacak.`
      }
    }
  },
  {
    id: 'kazakhstan-healthcare-violence-law',
    date: '2026-01-03',
    category: 'Diplomacy',
    image: 'https://www.qha.com.tr/cdn/MRURmu4U4sAqq2njCfw0Lpy31fE=/750x500/webp/2026/01/03/kazakistan-da-saglikta-siddete-agir-darbe-tokayev-yeni-yasayi-onayladi-1767425066-863_large.webp',
    featured: false,
    translations: {
      en: {
        title: "Heavy Blow to Healthcare Violence in Kazakhstan: Tokayev Approves New Law",
        excerpt: "Kazakhstan President Tokayev approved the new legal regulation that punishes violence against healthcare personnel.",
        content: `President Kassym-Jomart Tokayev signed the amendments to the Criminal Code to ensure the safety of healthcare workers.

**NEW CRIMINAL ARTICLE FOR HEALTHCARE WORKERS**

Article "380-3" provides deterrent sanctions for acts of violence against healthcare workers.

**12 YEARS IN PRISON FOR LIFE-THREATENING ATTACKS**

Courts can impose prison sentences ranging from five years to twelve years for serious attacks.`
      },
      tr: {
        title: "Kazakistan'da sağlıkta şiddete ağır darbe: Tokayev yeni yasayı onayladı",
        excerpt: "Kazakistan Cumhurbaşkanı Tokayev, sağlık personeline yönelik şiddeti ağır hapis cezalarıyla cezalandıran yeni yasayı onayladı.",
        content: `Cumhurbaşkanı Kasım Cömert Tokayev, sağlık çalışanlarının güvenliğini sağlamak amacıyla Ceza Kanunu değişikliklerini imzaladı.

**SAĞLIK ÇALIŞANLARI İÇİN YENİ CEZA MADDESİ**

"380-3" numaralı madde, sağlık çalışanlarına yönelik şiddet için caydırıcı yaptırımlar öngörüyor.

**YAŞAMI TEHDİT EDEN SALDIRILARA 12 YIL HAPİS**

Mahkemeler ciddi saldırılar için beş yıldan on iki yıla kadar hapis cezası verebilecek.`
      }
    }
  },
  {
    id: 'dandanakan-historical-discovery',
    date: '2026-01-02',
    category: 'Culture',
    image: 'https://www.qha.com.tr/cdn/B8KNzfNUpxYPk_SxCs4vc_rQrwY=/750x500/webp/2026/01/02/dandanakan-da-tarihi-kesif-1767354094-748_large.webp',
    featured: false,
    translations: {
      en: {
        title: "Historical Discovery in Dandanakan!",
        excerpt: "A historical ceramic lamp was found in Turkmenistan. The lamp is thought to belong to the 10th-12th centuries.",
        content: `A lamp thought to belong to the 10th to 12th centuries was discovered in the historical city of Dandanakan in Turkmenistan.

The ceramic lamp belongs to the Seljuk and Ghaznavid periods, made of terracotta and approximately 20 cm high.`
      },
      tr: {
        title: "Dandanakan'da tarihî keşif!",
        excerpt: "Türkmenistan'ın Dandanakan kentinde tarihî bir seramik lamba bulundu. Lambanın 10-12. yüzyıllara ait olduğu düşünülüyor.",
        content: `Türkmenistan'ın tarihî kenti Dandanakan'da 10. ile 12. yüzyıllarına ait olduğu düşünülen bir lamba tespit edildi.

Seramik lambanın Selçuklu ve Gazneliler dönemlerine ait olduğu, pişmiş topraktan yapıldığı ve yaklaşık 20 cm yüksekliğe sahip olduğu belirlendi.`
      }
    }
  },
  {
    id: 'turkic-leaders-2026-new-year-message',
    date: '2026-01-01',
    category: 'Summit',
    image: 'https://www.qha.com.tr/cdn/NpWzstKzsnUr0byqOJDqDQYZDmA=/750x500/webp/2026/01/01/bagimsiz-turk-devletleri-liderlerinden-2026-yili-mesaji-1767270542-243_large.webp',
    featured: true,
    translations: {
      en: {
        title: "2026 New Year Message from Independent Turkic States Leaders",
        excerpt: "Leaders of independent Turkic states shared their new year celebration messages with wishes for success and unity.",
        content: `Leaders of independent Turkic states shared their new year celebration messages. Azerbaijan, Kyrgyzstan, Kazakhstan, Uzbekistan, Turkmenistan and TRNC entered 2026 with wishes for success.

**REPUBLIC OF TURKEY**
President Erdoğan: "Today we are saying goodbye to 2025 and getting ready to say hello to 2026 with new hopes."

**AZERBAIJAN**
President Aliyev: "I am sure that 2026 will also be successful for our country."

**KAZAKHSTAN**
President Tokayev: "I wish health, happiness and great success to all citizens of Kazakhstan."`
      },
      tr: {
        title: "Bağımsız Türk devletleri liderlerinden 2026 yılı mesajı",
        excerpt: "Bağımsız Türk devletleri liderleri yeni yıl kutlama mesajlarını paylaştı.",
        content: `Bağımsız Türk devletleri liderleri yeni yıl kutlama mesajlarını paylaştı. Azerbaycan, Kırgızistan, Kazakistan, Özbekistan, Türkmenistan ve KKTC 2026 yılına başarı temennileriyle girdi.

**TÜRKİYE CUMHURİYETİ**
Cumhurbaşkanı Erdoğan: "Bugün 2025 ile vedalaşıyor, yeni ümitlerle 2026'ya merhaba demeye hazırlanıyoruz."

**AZERBAYCAN**
Cumhurbaşkanı Aliyev: "Eminim ki, 2026 yılı da ülkemiz için başarılı olacak."

**KAZAKİSTAN**
Cumhurbaşkanı Tokayev: "Kazakistan'ın tüm vatandaşlarına sağlık, mutluluk ve büyük başarılar diliyorum."`
      }
    }
  }
];

export const getNewsById = (id) => newsData.find(news => news.id === id);

export const getLocalizedNews = (news, language) => {
  if (!news) return null;
  const lang = news.translations[language] ? language : 'en';
  return { ...news, ...news.translations[lang] };
};
